import Vue from 'vue'
import Vuex from 'vuex'
import { Toast } from "mint-ui";
Vue.component(Toast.name, Toast);
Vue.use(Vuex)
//state
const state = {
  //数据
  popupVisible: false,
  direction: 'forward',         //路由过渡方向
  topicList:[],                 //选择话题数组
  aitFriendList:[],              //艾特朋友数组
  tempTabTypeId:''              //首页tab选择的值 
}

//getters
const getters = {
}

//mutations
const mutations = {
  updateTabTypeId(state,tempTabTypeId){
    state.tempTabTypeId = tempTabTypeId
  },
  updateDirection(state, direction) {           //更新路由过渡方向
    state.direction = direction
  },
  addTopicList(state, topicName){
    // debugger
    if(state.topicList.indexOf(topicName)>-1){
      return state.topicList;
    }else{
      if(state.topicList.length==5){
        Toast(this.$t("lessThanFiveTopicTxts"));
        return;
      } 
      return state.topicList=[...state.topicList,...[topicName]]
    }
  },
  delTopicList(state, topicName){
    // debugger
    state.topicList.splice(state.topicList.indexOf(topicName),1)
  },
  addFriendList(state,friendData){
    // debugger
    if(JSON.stringify(state.aitFriendList).indexOf(JSON.stringify(friendData))>-1){
      return state.aitFriendList;
    }else{
      if(state.aitFriendList.length==10){
        Toast(this.$t("lessThanTenFriendTxt"));
        return;
      } 
      return state.aitFriendList=[...state.aitFriendList,...[friendData]]
    }
  },
  delFriendList(state, friendData){
    // debugger
    state.aitFriendList=state.aitFriendList.map((e)=>{
      return e=JSON.stringify(e)
    })
    state.aitFriendList.splice(state.aitFriendList.indexOf(JSON.stringify(friendData)),1)
    state.aitFriendList=state.aitFriendList.map((e)=>{
      return e=JSON.parse(e)
    })
  },
}

//actions
//更新用户数据
const actions = {
  update_tabTypeId({commit},tempTabTypeId){
    commit('updateTabTypeId',tempTabTypeId)
  },
  add_topic_list({commit},topicName){
    commit('addTopicList',topicName)
  },
  del_topic_list({commit},topicName){
    commit('delTopicList',topicName)
  },
  add_friend_list({commit},friendData){
    commit('addFriendList',friendData)
  },
  del_friend_list({commit},friendData){
    commit('delFriendList',friendData)
  },
}

export default new Vuex.Store({
  state, mutations, getters, actions
})



// WEBPACK FOOTER //
// ./src/vuex/store.js